import { render, staticRenderFns } from "./yous.vue?vue&type=template&id=c9ae67e4&scoped=true"
import script from "./yous.vue?vue&type=script&lang=js"
export * from "./yous.vue?vue&type=script&lang=js"
import style0 from "./yous.vue?vue&type=style&index=0&id=c9ae67e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ae67e4",
  null
  
)

export default component.exports